import React, { useContext } from 'react';
import { Tooltip } from '@mui/material';
import { collapseString } from '../../utils/collapseString';
import TableStyles from '../documents/Table.module.css';
import { AppContext } from '../../App';

interface ICollapsedTitleWithTooltip {
  title: string;
  clickToCopy?: boolean;
  charsFirstAndLast?: number;
  cypressId?: string;
}
const CollapsedTitleWithTooltip = ({
  title,
  clickToCopy = false,
  charsFirstAndLast = 15,
  cypressId,
}: ICollapsedTitleWithTooltip) => {
  const { setToast } = useContext(AppContext);

  // if character count is less than char limit
  if (title?.length <= charsFirstAndLast * 2) {
    return <span data-cy={cypressId}>{title}</span>;
  }

  const collapsedString = collapseString(title, charsFirstAndLast, charsFirstAndLast);

  return (
    <Tooltip title={title} placement="top">
      {clickToCopy ? (
        <span
          className={TableStyles.pointer}
          data-cy={cypressId}
          onClick={() => {
            navigator.clipboard.writeText(title);
            setToast({
              open: true,
              message: 'Copied!',
              variant: 'success',
            });
          }}
        >
          {collapsedString}
        </span>
      ) : (
        <span data-cy={cypressId}>{collapsedString}</span>
      )}
    </Tooltip>
  );
};

export default CollapsedTitleWithTooltip;
